import { createSlice } from '@reduxjs/toolkit'

export const customerTagsSlice = createSlice({
    name: 'customerTags',
    initialState: {
        clearFilters: false,
        clearSelectedTagUIDs: false,
        columns: [],
        columnsSynched: true,
        columnsFullDisplay: false,
        criteria: null,
        data: [],
        dataState: {
            filter: [],
            sort: [],
        },
        lastDataRequest: null,
        lastDataRetrieval: null,
        serviceTypes: [],
    },
    reducers: {
        custTagsAPIDataAdded: (state, action) => {
            state.assetFields = action.payload.assetFields
            state.clearSelectedTagUIDs = false
            state.columnsFullDisplay = true
            state.columnsSynched = false
            state.data = action.payload.data
            state.lastDataRetrieval = new Date()
            state.serviceTypes = action.payload.serviceTypes
        },
        custTagsAPIDataChanged: (state, action) => {
            state.data = action.payload
        },
        custTagsClearFiltersChanged: (state, action) => {
            state.clearFilters = action.payload
        },
        custTagsClearSelectedTagUIDsChanged: (state, action) => {
            state.clearSelectedTagUIDs = action.payload
        },
        custTagsColumnsChanged: (state, action) => {
            state.columns = action.payload
            state.columnsSynched = true
        },
        custTagsColumnsFullDisplayChanged: (state, action) => {
            state.columnsSynched = false
            state.columnsFullDisplay = action.payload
        },
        custTagsCriteriaChanged: (state, action) => {
            state.criteria = action.payload
            state.lastDataRequest = new Date()
        },
        custTagsDataStateChanged: (state, action) => {
            state.dataState = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    custTagsAPIDataAdded,
    custTagsAPIDataChanged,
    custTagsClearFiltersChanged,
    custTagsClearSelectedTagUIDsChanged,
    custTagsColumnsChanged,
    custTagsColumnsFullDisplayChanged,
    custTagsCriteriaChanged,
    custTagsDataStateChanged,
} = customerTagsSlice.actions

export default customerTagsSlice.reducer
